import combineReducer from './reducers';
import { configureStore } from '@reduxjs/toolkit';

const store = configureStore({ reducer: combineReducer });

export default store;
